import { Base } from './base.model';

export class WelcomeDocument extends Base {
  public name: string;
  public identifier: string;
  public description: string;
  public enrollmentGroupId: number;
  public isContract: boolean;
}
